import request from '../utils/request'
import global from '../config/global'

function list_countries(params = {}) {
  return request({
    url: global.endpoint.RESOURCE_COUNTRIES,
    method: 'get',
    params
  })
}

function list_mail_providers(params = {}) {
  return request({
    url: global.endpoint.RESOURCE_MAIL_PROVIDERS,
    method: 'get',
    params
  })
}

function list_access_log_clients(params = {}) {
  return request({
    url: global.endpoint.RESOURCE_ACCESS_LOG_CLIENTS,
    method: 'get',
    params
  })
}

function list_programming_languages(params = {}) {
  return request({
    url: global.endpoint.RESOURCE_PROGRAMMING_LANGUAGES,
    method: 'get',
    params
  })
}

export default {
  list_countries,
  list_mail_providers,
  list_access_log_clients,
  list_programming_languages
}
